import React from 'react';
import { Segment } from 'semantic-ui-react';
import DataGrid, { Column, Editing, Export, Form, Pager, Paging, Popup, Position, SearchPanel, Sorting } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import 'devextreme-react/text-area';
import { withTranslation } from 'react-i18next';
import { UnderlinedHeader } from '../../../components';
import { sizesDataGrid } from '../../../Data Stores';
import LoadingGifImage from '../../../res/images/loading.gif';
import datagridExporter from '../../../helpers/datagridExporter';

const Sizes = ({ t, PERMISSIONS }) => {
    return (
        <Segment basic>
            <UnderlinedHeader title={t('Sizes')} color='blue' />
            <Segment basic>
                <DataGrid
                    dataSource={sizesDataGrid}
                    showBorders
                    remoteOperations
                    columnHidingEnabled
                    wordWrapEnabled
                    columnAutoWidth
                    repaintChangesOnly
                    loadPanel={{ indicatorSrc: LoadingGifImage }}
                    columnChooser={{ enabled: true, mode: 'select' }}
                    onExporting={datagridExporter}
                >
                    <Paging defaultPageSize={10} />
                    <Sorting mode='multiple' />
                    <SearchPanel visible />
                    <Editing
                        mode='popup'
                        useIcons
                        allowUpdating={PERMISSIONS?.EDIT?.granted}
                        allowDeleting={PERMISSIONS?.DELETE?.granted}
                        allowAdding={PERMISSIONS?.ADD?.granted}
                        refreshMode='reshape'
                    >
                        <Popup title={t('SizeInfo')} showTitle resizeEnabled >
                            <Position my="middle" at="middle" of={window} />
                        </Popup>
                        <Form>
                            <Item itemType="group" colCount={2} colSpan={2}>
                                <Item isRequired dataField="nameEn" />
                                <Item isRequired dataField="nameAr" />
                                <Item dataField='isActive' />
                            </Item>
                        </Form>
                    </Editing>
                    <Pager
                        showPageSizeSelector
                        allowedPageSizes={[10, 20, 50, 100, 500, 1000]}
                        showInfo
                        showNavigationButtons
                    />
                    <Column dataField="nameEn" caption={t('EnglishName')} />
                    <Column dataField="nameAr" caption={t('ArabicName')} />
                    <Column dataField="creatAt" dataType="date" caption={t('CreatedAt')} />
                    <Column
                        caption={t('Active')}
                        dataType="boolean"
                        dataField='isActive'
                        width={100}
                    />
                   <Export enabled={PERMISSIONS?.EXPORT?.granted} />
                </DataGrid>
            </Segment>
        </Segment>
    );
};

export default withTranslation()(Sizes);
